import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar.jsx";
import { NotificationProvider } from "../../context/NotificationContext.jsx";

// ─────────────────────────────────────────────────────────────────────────────
//  AppLayout
//
//  Enveloppe toute l'application avec NotificationProvider.
//  Cela permet à Topbar et Sidebar de partager le même compteur de notifs
//  sans faire chacun leur propre appel API.
// ─────────────────────────────────────────────────────────────────────────────
export default function AppLayout() {
  return (
    <NotificationProvider>
      <div className="app-wrap">
        <Sidebar />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </NotificationProvider>
  );
}